export default class EnumObject {
  value: string;

  description: string;

  constructor(obj: any) {
    this.value = obj.value || ''
    this.description = obj.description || ''
  }

  public static of(obj: any): EnumObject {
    return new EnumObject(obj || {})
  }

  public static ofList(obj: any[]): EnumObject[] {
    return obj.map(this.of)
  }
}
